import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  FacebookShareButton,
  LinkedinShareButton,
  TwitterShareButton,
  WhatsappShareButton
} from "react-share";
import {
  FacebookIcon,
  LinkedinIcon,
  TwitterIcon,
  WhatsappIcon
} from "react-share";

const XIcon = ({ size = 32, color = "#fff" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    style={{ display: "block" }}
  >
    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24h-6.514l-5.106-6.694L2.896 21.75H.588l7.753-8.835L.461 2.25h6.679l4.632 6.132 5.484-6.132z" />
  </svg>
);


const SharePost = (props) => {
  const { postId, type, link = null } = props;
  // const shareUrl = 'https://hellosuperstars.com/';

  const [shareUrl, setSharePost] = useState();

  useEffect(() => {
    if (type === "fanpostshare") {
      props.onMoveData(1);
      setSharePost(`https://hellosuperstars.com?post=${parseInt(postId)}`)
      // axios.get(`/api/user/fan/post/share/${parseInt(postId)}`).then((res) => {
      //   if (res.status === 200) {
      //     if(res.data.post.share_link !=null) {
      //       setSharePost(res.data.post.share_link);
      //     }else
      //     {
      //       setSharePost("https://hellosuperstars.com/")
      //     }
      //   }
      // });
    }
    if (type === "postshare") {
      props.onMoveData(1);
      setSharePost(`https://hellosuperstars.com?post=${parseInt(postId)}`)
      // axios.get(`/api/user/post/share/${parseInt(postId)}`).then((res) => {
      //   if (res.status === 200) {
      //     if(res.data.post.share_link !=null) {
      //      // setSharePost(res.data.post.share_link);
      //     }else
      //       {
      //      //   setSharePost("https://hellosuperstars.com/")
      //       }
      //   }
      // });
    }
    if (type === "greetingShare") {
      setSharePost(link);
    }
  }, []);

  const handleShareCount = () => {
    props.onMoveData(1);
    axios.post(`/api/user/post/share/store/${parseInt(postId)}`).then((res) => {
      if (res.status === 200) {
        props.onShare(prev => prev + 1);
        props.closeShare();
      }
    });
  };

  const handleShareFanCount = () => {
    props.onMoveData(1);
    axios
        .post(`/api/user/fan/post/share/store/${parseInt(postId)}`)
        .then((res) => {
          if (res.status === 200) {
          }
        });
  };

  return (
      <>
        <div className="MediaBG mt-3">
          <div className="d-flex p-3">
            <FacebookShareButton
                className="mx-2"
                url={shareUrl}
                quote={"Hi helloSuperStar, This is my fist post in Facebook"}
                onClick={
                  type === "postshare"
                      ? handleShareCount
                      : type === "fanpostshare"
                      ? handleShareFanCount
                      : ""
                }
            >
              <FacebookIcon size={32} round={true} />
            </FacebookShareButton>

            <TwitterShareButton
              className="mx-2"
              url={shareUrl}
              title="Hi helloSuperStar, This is my first post on X!"
              onClick={
                type === "postshare"
                  ? handleShareCount
                  : type === "fanpostshare"
                  ? handleShareFanCount
                  : undefined
              }
            >
              <div
                style={{
                  width: 32,
                  height: 32,
                  borderRadius: "50%",
                  background: "#000",
                  color: "#fff",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  lineHeight: 0,
                  boxSizing: "border-box",
                  textAlign: "-webkit-center",
                }}
              >
                <XIcon size={16} />
              </div>
            </TwitterShareButton>

            {/* <LinkedinShareButton
                className="mx-2"
                url={shareUrl}
                quote={"Hi helloSuperStar, This is my fist post in Facebook"}
                onClick={
                  type === "postshare"
                      ? handleShareCount
                      : type === "fanpostshare"
                      ? handleShareFanCount
                      : ""
                }
            >
              <LinkedinIcon size={32} round={true} />
            </LinkedinShareButton> */}

            <WhatsappShareButton
                className="mx-2"
                url={shareUrl}
                quote={"Hi helloSuperStar, This is my fist post in Facebook"}
                onClick={
                  type === "postshare"
                      ? handleShareCount
                      : type === "fanpostshare"
                      ? handleShareFanCount
                      : ""
                }
            >
              <WhatsappIcon size={32} round={true} />
            </WhatsappShareButton>
          </div>
        </div>
      </>
  );
};

export default SharePost;
